module.exports = __webpack_public_path__ + "media/images/sp/brands/common/logo_aqua-b9c9dd4df435ee48a1df6b1d524d193b.svg";